import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSketch = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 5.59803C11.25 5.59803 14.4125 2.83251 15.9938 4.06761C18.3502 5.90813 13.3584 8.14891 13.8854 9.16903C14.4125 10.1891 17.9368 7.98854 19.6834 9.679C20.7376 10.6993 20.0694 12.1294 19.6834 13.25",
			stroke: "currentcolor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 12,
			r: 3.75,
			stroke: "currentcolor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.75 20.25L15 13.75L19.25 20.25H10.75Z",
			stroke: "currentcolor",
			strokeWidth: 1.5
		})
	]
});
export default SvgSketch;
